import { render, staticRenderFns } from "./TemplateVerboseAbbreviationWidget.vue?vue&type=template&id=077cbdb1&"
import script from "./TemplateVerboseAbbreviationWidget.vue?vue&type=script&lang=ts&"
export * from "./TemplateVerboseAbbreviationWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports